// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface IRenewalPlanLiteDto
 */
export interface IRenewalPlanLiteDto {
    /**
     * 
     * @type {number}
     * @memberof IRenewalPlanLiteDto
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof IRenewalPlanLiteDto
     */
    plan_code?: string;
}

/**
 * Check if a given object implements the IRenewalPlanLiteDto interface.
 */
export function instanceOfIRenewalPlanLiteDto(value: object): value is IRenewalPlanLiteDto {
    return true;
}

export function IRenewalPlanLiteDtoFromJSON(json: any): IRenewalPlanLiteDto {
    return IRenewalPlanLiteDtoFromJSONTyped(json, false);
}

export function IRenewalPlanLiteDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IRenewalPlanLiteDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'plan_code': json['plan_code'] == null ? undefined : json['plan_code'],
    };
}

export function IRenewalPlanLiteDtoToJSON(json: any): IRenewalPlanLiteDto {
    return IRenewalPlanLiteDtoToJSONTyped(json, false);
}

export function IRenewalPlanLiteDtoToJSONTyped(value?: IRenewalPlanLiteDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'plan_code': value['plan_code'],
    };
}

